import { defineMessages } from 'react-intl'

const scope = 'app.containers.Groups'

export default defineMessages({
  header: {
    id: `${scope}.header`,
    defaultMessage: 'All Groups',
  },
  columns: {
    name: {
      id: `${scope}.columns.name`,
      defaultMessage: 'Group Name',
    },
    zones: {
      id: `${scope}.columns.zones`,
      defaultMessage: 'Associated Zones',
    },
    actions: {
      id: `${scope}.columns.actions`,
      defaultMessage: 'Actions',
    },
  },
})
